import { createStyles } from "@material-ui/core";
import { getTheme } from "../../Themes";

const theme = getTheme();

export default createStyles({
  closeButton: {
    position: 'absolute',
    right: '8px',
    top: '5px',
    color: theme.palette.text.primary,
  },
  contentTableRow: {
    borderCollapse: 'separate',
    borderRadius: '5px',
    marginBottom: '1px',
  },
  detailsIcon: {
    transform: 'rotate(0.5turn) rotateX(45deg)',
    display: 'block',
    margin: '0 auto',
  },
  iconStyle: {},
  paperOverflow: {
    background: 'none',
    boxShadow: 'none',
  },
  tableContainer: {
    padding: '0px',
    overflow: 'auto',
    maxHeight: 'calc(100vh - 124px)',
  },
  videoPlayer: {
    maxWidth: '100%',
    margin: '0 auto',
    marginTop: '20px',
    display: 'block',
  },
  thumbnail: {
    zIndex: 1201,
    position: 'fixed',
    marginTop: '-135px',
    marginLeft: '-30px',
  },
  muiTablePaginationCaption: {},
  reduceSvgIconSize: {
    '& svg': {
      transform: 'scale(0.7)',
    },
  },
  resultDetails: {
    fontFamily: 'roboto',
    fontWeight: 500,
    width: '30%',
    marginRight: '30px',
    marginLeft: '30px',
    textAlign: 'center',
    color: theme.palette.primary.main,
    paddingTop: '0px',
    paddingLeft: '10px',
    paddingBottom: '0px',
    top: '0px',
    zIndex: 1,
  },
  noMusic: {
    paddingLeft: '5px',
    padding: '2px',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  buttonDense: {
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  title: {
    flex: '1 1 100%',
  },
  caption: {
    flex: '1 1 100%',
  },
});